import { SL_WORKSPACE_PROFILE } from '@app/sl-workspace/profile';
import { hasLoginCookie } from '@core/util/cookies';
import { createSignal } from 'solid-js';
import { shouldEnableInitialUserInfoQuery } from './user-info-bootstrap';

const [shouldQueryUserInfo, setShouldQueryUserInfo] = createSignal(
  shouldEnableInitialUserInfoQuery(
    SL_WORKSPACE_PROFILE.enabled,
    hasLoginCookie()
  )
);

export { shouldQueryUserInfo };

export function enableUserInfoQuery() {
  setShouldQueryUserInfo(true);
}
